module.exports = __webpack_public_path__ + "static/media/RO_Plant.85601075.png";